import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={36}
    height={36}
    viewBox={'0 0 36 36'}
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || '#2D27F6'}
      d="M17.95 35.482c9.78 0 17.7-7.92 17.7-17.7S27.73.082 17.95.082.25 8.002.25 17.782s7.92 17.7 17.7 17.7Zm.98-29.21a2.95 2.95 0 0 1 2.95 2.95 2.95 2.95 0 1 1-5.9 0 2.95 2.95 0 0 1 2.95-2.95Zm-.98 7.28c2.95 0 3.67 1.74 3.34 3.89l-1.37 8.9s.98 0 2.95-.98c0 0-.98 3.93-4.92 3.93-2.95 0-3.67-1.74-3.34-3.89l1.37-8.9s-.98 0-2.95.98c0 0 .98-3.93 4.92-3.93Z"
    />
  </Svg>
);
export default SvgComponent;
